import React from 'react';
import Login from './Login';
import {useDispatch, useSelector} from 'react-redux';
import {toggleModal, actionLogin, saveTemp, actionSendLinkReset, actionLoginError} from '../../redux/actions';
import Register from "./Register";
import CloseBtn from "../common/CloseIcon";
import {ChangePassword, SendLink} from "./ChangePassword";
import {RootState} from "../../redux/reducers";


export const PreCaution = () => {

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const dispatch = useDispatch();

    const closeModal = () => {
        dispatch(toggleModal());
    }

    const openOld = () => {
        window.location.href='https://www.kultuurikava.ee/mobile';
    }

    return <div className="precaution">
        <div className='close-btn' onClick={closeModal}>
            <CloseBtn/>
        </div>
        <div className="login">
            <h2>NB!</h2>
            <p>
            Ürituste lisamiseks, redigeerimiseks ja konto seadete muutmiseks suuname Sind desktop-vaatesse.
            </p>
            <button type="button" className="btn btn-success" onClick={openOld}>Jätka</button>
        </div>
    </div>
}

export const RegistrationConfirm = () => {
    const dispatch = useDispatch();
    // @ts-ignore
    const tempData = useSelector((state:RootState) => state.tempStore)
    const closeModal = () => {
        dispatch(toggleModal());
        if (tempData.username && tempData.password) {
            dispatch(actionLogin(tempData))
            dispatch(saveTemp({
                username: null,
                password: null
            }))
        }

    }
    return <div className="precaution">
        <div className='close-btn' onClick={closeModal}>
            <CloseBtn/>
        </div>
        <div className="login">
            <h2>Õnnestus!</h2>
            <p/>
            <button type="button" className="btn btn-success" onClick={closeModal}>Sulge</button>
        </div>
    </div>
}

export const LoginError = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const dispatch = useDispatch();

    const closeModal = () => {
        dispatch(actionLoginError(''));
        dispatch(toggleModal());
    }

    return <div className="precaution">
        <div className='close-btn' onClick={closeModal}>
            <CloseBtn/>
        </div>
        <div className="login">
            <p>
                Vale kasutajanimi või parool!
            </p>
            <button type="button" className="btn btn-success" onClick={closeModal}>Sulge</button>
        </div>
    </div>
}


const Modal = (props: any) => {
    const { dialog } = props
//    const dispatch = useDispatch();
    // const closeModal = (e:any) => {
    //     if (e.target.id && e.target.id === 'backdrop') {
    //         dispatch(toggleModal());
    //     }
    // }

    let component = <Login />
    if (dialog === 'login') {
        component = <Login />
    } else if (dialog === 'precaution') {
        component = <PreCaution />
    } else if (dialog === 'loginError') {
        component = <LoginError />
    } else if (dialog === 'register') {
        component = <Register />
    } else if (dialog === 'sendlink') {
        component = <SendLink />
    } else if (dialog === 'changepassword') {
        component = <ChangePassword />
    } else if (dialog === 'registrationconfirm') {
        component = <RegistrationConfirm />
    }

    return <div className='modal-backdrop' id='backdrop' >
        <div className='modal-content'>
            {component}
        </div>
    </div>
}

export default Modal;
